<div class="container">
    <div class="edit" *ngIf="view === 'edit'">
        <div class="edit-label">Champs communs</div>
    </div>

    <div class="field-container">
        <ng-container *ngIf="view === 'edit'">
            <div class="field common-field" *ngFor="let field of commonFields; let i = index">
                <div class="header-field">
                    <div class="field-type">
                        <div class="header-label">
                            <span class="header-type">[{{ getTypeName(field.type) }}]</span>
                            {{ field.label }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="edit" *ngIf="view === 'edit'">
            <div class="edit-label">Champs personnalisés</div>
            <button mat-icon-button color="primary" matTooltip="Ajouter un champ" matTooltipPosition="above" [matMenuTriggerFor]="menu">
                <mat-icon>add</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item *ngFor="let type of fieldTypes" (click)="addField(type.code)">
                    <span>{{ type.name}}</span>
                </button>
            </mat-menu>
        </div>

        <div class="no-customfield" *ngIf="view === 'edit' && fields.length === 0">
            Aucun champ personnalisé.
        </div>

        <div class="field" *ngFor="let field of fields; let i = index">
          <div class="header" *ngIf="view === 'edit'">
              <div class="field-type">
                  <button mat-icon-button color="primary" *ngIf="!isCollapsed(field)"
                      (click)="collapse(field)" matTooltip="Réduire">
                      <mat-icon>expand_less</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="isCollapsed(field)"
                      (click)="expand(field)" matTooltip="Développer">
                      <mat-icon>expand_more</mat-icon>
                  </button>
                  <div class="header-label">
                      <span class="header-type">[{{ getTypeName(field.type) }}]</span>
                      {{ field.label }}
                  </div>
                  <button mat-icon-button color="primary" (click)="down(i)"
                      matTooltip="Déplacer vers le bas" [disabled]="i === fields.length - 1">
                      <mat-icon>arrow_downward</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" (click)="up(i)"
                      matTooltip="Déplacer vers le haut" [disabled]="i === 0">
                      <mat-icon>arrow_upward</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="removeField(i)" matTooltip="Supprimer">
                      <mat-icon>delete</mat-icon>
                  </button>
              </div>
          </div>
          <mat-form-field appearance="outline" class="content"
              *ngIf="view === 'edit' && !isCollapsed(field)">
              <mat-label>Label</mat-label>
              <input matInput id="" required [ngModel]="field.label" (ngModelChange)="updateLabel(field, $event)"  />
          </mat-form-field>
          <app-generic-field class="content" [view]="view"
              *ngIf="view !== 'edit' || !isCollapsed(field)"
              [field]="field" (fieldChange)="updateField(i, $event)"></app-generic-field>
      </div>
    </div>
</div>
